module.exports = __webpack_public_path__ + "80ea5cb89df29b6337fd7d371e8c520c.png";